<section class="services-section section">
    <div class="container">
        <div class="section-title">
            <h2>Services</h2>
        </div>
        <div class="serivces-wrapper">
            <div class="serviceCard" *ngFor="let service of servicesData.servicesList">
                <img class="service-icon" [src]="service.icon">
                <img class="service-icon-active" [src]="service.activeIcon">
                <h3 class="service-title">{{service.title}}</h3>
                <p class="service-description">{{service.description}}</p>
            </div>

        </div>
    </div>
</section>